module.exports = __webpack_public_path__ + "img/crop2_active.2017337a.png";